(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-shrd-3tenx"] && !Shopify.designMode) return;
  try {
    
(function(){
  var mq = window.matchMedia('(max-width:600px)');
  function sync(){
    document.querySelectorAll('.sx-foot__col-btn').forEach(function(btn){
      if (mq.matches){
        btn.removeAttribute('tabindex');
        btn.setAttribute('aria-expanded', btn.closest('.sx-foot__col').classList.contains('is-open') ? 'true' : 'false');
      } else {
        btn.setAttribute('tabindex', '-1');
        btn.removeAttribute('aria-expanded');
      }
    });
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest ? e.target.closest('.sx-foot__col-btn') : null;
    if (!btn || !mq.matches) return;
    var col = btn.closest('.sx-foot__col');
    var open = !col.classList.contains('is-open');
    col.closest('.sx-foot').querySelectorAll('.sx-foot__col.is-open').forEach(function(c){
      c.classList.remove('is-open');
      c.querySelector('.sx-foot__col-btn').setAttribute('aria-expanded', 'false');
    });
    col.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  if (mq.addEventListener) { mq.addEventListener('change', sync); } else { mq.addListener(sync); }
  document.addEventListener('shopify:section:load', sync);
  sync();
})();

  } catch(e) { console.error(e); }
})();
})();
